import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { Form } from 'react-bootstrap';
import Spinner, { spinnerOff, spinnerOn } from '../../../components/Spinner';
import { getAttachments, getJobJournalCategories, getJournal, getProjectJournalAssets } from '../../../api';
import { projectStatusCodeMap } from '../../../components/ProjectStatusCodeMap';
import { Breadcrumb, DatePicker } from 'antd';
import './job_journal.css';
import { isViewOnlyOrExternalView } from '../../../utils/UserInfo';
import axios from 'axios';
import Moment from 'moment';
import Errors from '../../../components/Errors';
import { CalendarOutlined, CloseOutlined } from '@ant-design/icons';
import { FORM_MODE_EDIT, FORM_MODE_NEW, FORM_MODE_VIEW } from './index';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import IPSLocationAssetCollapse from 'containers/PreEForm/PreEFormFields/IPSLocations/IPSLocationAssetCollapse';
import { oktaAuth } from 'oktaConfig';

const leftAlignLabel = {
    style: {
        textAlign: "left",
        fontWeight: "bold"
    }
};

const errorStyle = {
    color: 'red'
};

class NewJobJournal extends Component {
    state = {
        journal: {
            id: "",
            projectId: "",
            problem: "",
            resolution: "",
            engineerName: "",
            dateDiscovered: "",
            dateResolved: "",
            delayInProject: "",
        },
        attachments: [],
        fileList: {},
        Data: [],
        fileName: "",
        fileListName: "",
        noOfFilesError: null,
        fileSize: null,
        filesizeOk: true,
        events: [],
        fileCount: null,
        jobJournalCategories: [],
        openModal: false,
        selectedLocationAssets: []
    }

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDiscoverDateChange = this.handleDiscoverDateChange.bind(this);
        this.handleResolvedDateChange = this.handleResolvedDateChange.bind(this);
        this.handleJobJournalBack = this.handleJobJournalBack.bind(this);
        this.handleSaveAndExit = this.handleSaveAndExit.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.deleteSelectedFile = this.deleteSelectedFile.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.handleselectedFile = this.handleselectedFile.bind(this);
        this.closeErrorBox = this.closeErrorBox.bind(this);
        this.dateValidationErrorDialog = this.dateValidationErrorDialog.bind(this);
    }

    async componentDidMount() {
        spinnerOn();
        const params = this.props.match.params;
        const jobJournalCategories = await getJobJournalCategories();
        if (params.id === "new") {
            const journal = {
                id: "",
                projectId: params.projectId,
                problem: "",
                resolution: "",
                engineerName: "",
                dateDiscovered: "" || Moment().format('MMMM DD, YYYY'),
                dateResolved: "",
                delayInProject: "",
            }
            const fileList = {
                fileList: {},
            }
            this.setState({ journal, fileList, jobJournalCategories });
        } else {
            const journal = await getJournal(params.projectId, params.id);
            const attachments = await getAttachments(params.id);
            this.setState({ attachments: attachments });
            this.setState({ journal, jobJournalCategories });
            this.setState({selectedLocationAssets: this.filterSelectedAssets(journal.jobJournalMappings)})
            
        }
        const projectAssets = await getProjectJournalAssets(params.projectId);
        this.setState({projectAssets: projectAssets})
        spinnerOff();
    }

    getFormModeText() {
        switch (this.props.formMode) {
            case FORM_MODE_EDIT:
                return 'Edit';
            case FORM_MODE_NEW:
                return 'New';
            default:
                return 'View';
        }
    }

    handleInputChange(e) {
        const { journal } = this.state;
        const currentJournal = journal;
        const { value, name } = e.target;
        currentJournal[name] = value;

        this.setState({ journal: currentJournal });
    }

    handleDiscoverDateChange(date) {

        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        this.setState({ myDate });
        const { journal } = this.state;
        const currentJournal = journal;
        currentJournal["dateDiscovered"] = myDate;

        this.setState({ journal: currentJournal });
    }

    handleResolvedDateChange(date) {
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        const { journal } = this.state;
        const currentJournal = journal;
        currentJournal["dateResolved"] = myDate;

        this.setState({ journal: currentJournal });
    }

    filterSelectedAssets(locations) {
        const selectedAssets = locations.map(location=> ({ipsLocationId: location.ipsLocationId, assetIds:location.assets.map(asset=> asset.assetId)}))
        return selectedAssets? selectedAssets: []
      }

      handleCheckboxSelect = (asset) =>{
        let selectedLocationAssets = []
        if( this.state.selectedLocationAssets.length==0) {
          this.setState({selectedLocationAssets: [{ipsLocationId: asset.ipsLocationId, assetIds: [asset.assetId]}]})
          
        } else {
          const locations = this.state.selectedLocationAssets.filter(l=> l.ipsLocationId===asset.ipsLocationId)
          let location = null;
          if(locations.length>0) {
            location = locations[0].assetIds.includes(asset.assetId)? 
            {ipsLocationId:locations[0].ipsLocationId, assetIds: locations[0].assetIds.filter(id=> id!=asset.assetId)}
            : 
            {ipsLocationId:locations[0].ipsLocationId, assetIds: [...locations[0].assetIds, asset.assetId]}
            this.state.selectedLocationAssets.map(l=> l.ipsLocationId==location.ipsLocationId? location: l)
            this.setState({selectedLocationAssets: this.state.selectedLocationAssets.map(l=> l.ipsLocationId==location.ipsLocationId? location: l)})
          } else {  
            this.setState({selectedLocationAssets: [...this.state.selectedLocationAssets, {ipsLocationId: asset.ipsLocationId, assetIds: [asset.assetId]}]})
          }
          
        }
      }

      handleIpsLocationSelect =(location) => {

        const locations = this.state.selectedLocationAssets.length>0 ?this.state.selectedLocationAssets.map(loc => loc.ipsLocationId===location.ipsLocationId? {ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)}
        : loc)
        : [{ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)}]
    
        locations.filter(loc=> loc.ipsLocationId!=location.ipsLocationId).length>0 && locations.push( {ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)})
        
        const isAllSelected = this.state.selectedLocationAssets.length>0 ? this.state.selectedLocationAssets.filter(loc => loc.ipsLocationId === location.ipsLocationId && loc.assetIds.length ===location.assets.length).length>0: false
          if(isAllSelected){
            this.setState({selectedLocationAssets: this.state.selectedLocationAssets.filter(loc=> loc.ipsLocationId!=location.ipsLocationId)})
          } else {
          this.setState({selectedLocationAssets: locations})
        }
      }

    render() {
        const { journal, error, noOfFilesError, fileSize, jobJournalCategories } = this.state;
        const { project, status } = this.props;
        const mode = this.getFormModeText();

        return (
            <Grid id={"jobJournal"} fluid>
                <Errors error={this.state.error}
                    onCloseBox={this.closeErrorBox} />
                <Row>
                    <Col md={4} xs={12}>
                        <Breadcrumb>
                            <Breadcrumb.Item><Link
                                to={`/${status}/${project.id}/journal`}
                                style={{ fontize: "30px" }}
                            >
                                Job Journal
                            </Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {journal && this.getFormModeText()}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Title*</Form.Label>
                            <Form.Control as="input" value={journal.title} name="title"
                                onChange={this.handleInputChange}
                                maxLength="100"
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])} />
                        </Form.Group>
                    </Col>
                    <Col md={4} mdOffset={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Category</Form.Label>
                            <Form.Control as="select" value={journal.jobJournalCategoryId || ''} name="jobJournalCategoryId" onChange={this.handleInputChange}
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])}>
                                <option
                                    id="category"
                                    key=""
                                    value=""
                                ></option>
                                {jobJournalCategories && jobJournalCategories.map((jobJournalCategory, jobJournalCategoryId) => (
                                    <option
                                        id="jobJournalCategory"
                                        key={jobJournalCategory.jobJournalCategoryId}
                                        value={jobJournalCategory.jobJournalCategoryId}
                                    >   {jobJournalCategory.jobJournalCategory}
                                    </option>
                                ))}

                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} xs={12}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}> Description of Problem*</Form.Label>
                            <Form.Control as="textarea" value={journal.problem} name="problem"
                                onChange={this.handleInputChange} rows="4"
                                maxLength="2400"
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} xs={12}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}> Description of Resolution</Form.Label>
                            <Form.Control as="textarea" value={journal.resolution} name="resolution"
                                onChange={this.handleInputChange} rows="4"
                                maxLength="2400"
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Date Discovered*</Form.Label>
                            <DatePicker
                                id="discoveredDateId"
                                onChange={this.handleDiscoverDateChange}
                                value={journal.dateDiscovered ? Moment(journal.dateDiscovered) : journal.dateDiscovered}
                                format={'MMMM DD, YYYY'}
                                name={"dateDiscovered"}
                                size={"large"}
                                suffixIcon={<CalendarOutlined />}
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4} mdOffset={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Date Resolved</Form.Label>
                            <DatePicker
                                id="resolvedDateId"
                                size={"large"}
                                onChange={this.handleResolvedDateChange}
                                value={journal.dateResolved ? Moment(journal.dateResolved) : journal.dateResolved}
                                format={'MMMM DD, YYYY'}
                                name={"dateResolved"}
                                suffixIcon={<CalendarOutlined />}
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Engineer Contacted</Form.Label>
                            <Form.Control as="input" value={journal.engineerName} name="engineerName"
                                onChange={this.handleInputChange}
                                maxLength="100"
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])} />
                        </Form.Group>
                    </Col>
                    <Col md={4} mdOffset={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Delay of Project</Form.Label>
                            <Form.Control as="input" value={journal.delayInProject} name="delayInProject"
                                onChange={this.handleInputChange}
                                maxLength="100"
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"])} />
                        </Form.Group>
                    </Col>
                </Row>
                
                <Form.Group as={Row} >
                    <Form.Label className="col-xs-12 col-md-12"><strong style={{float: 'left'}}> Project IPS Locations:</strong></Form.Label>
                </Form.Group>
                <IPSLocationAssetCollapse
                    preEForm={journal}
                    preEFormMappings={this.props.formMode==FORM_MODE_VIEW? this.state?.journal?.jobJournalMappings: this.state.projectAssets}  
                    editVisibleProps={this.props.formMode==FORM_MODE_VIEW}
                    selectedLocationAssets={this.state.selectedLocationAssets}
                    handleIpsLocationSelect = {this.handleIpsLocationSelect}
                    handleCheckboxSelect ={this.handleCheckboxSelect}
                    {...this.props} />
                
                {this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"] &&
                    !isViewOnlyOrExternalView() &&
                    <div style={{ marginTop: '24px' }}>
                        <div id="file-class">
                            < input
                                type="file"
                                className="file-input"
                                id="uploadJ"
                                name="upload"
                                accept=".mp4, .mov, .pdf, .xlsx, .csv, .png, .jpg, .img, .docx, .pptx"
                                onChange={this.handleselectedFile}
                                disabled={(mode === 'View') || (this.props.project.projectStatus === projectStatusCodeMap["CLOSED"] || isViewOnlyOrExternalView())}
                                multiple>
                            </input>

                            {this.state.attachments ? this.state.attachments.map(file => {
                                return (
                                    <div id={file.fileName}>
                                        <a href={file.fileName} download id="download" name="fileName"
                                            id="download-file"
                                            onClick={this.handleFile.bind(this, file)}>
                                            {file.fileName}
                                        </a>
                                        <span
                                            className="input-group-clear bg-light border-0"
                                            onClick={this.deleteSelectedFile.bind(this, file.fileName)}
                                        >
                                            <CloseOutlined />
                                        </span>
                                        <div><br /></div>
                                    </div>

                                );
                            }) : ""
                            }
                            {this.state.fileCount && this.state.fileCount > 5 ?
                                <div className="error-file" style={errorStyle}> {noOfFilesError}</div> : ""}
                            {!this.state.filesizeOk ?
                                <div className="error-file" style={errorStyle}> {fileSize}</div> : ""}
                        </div>
                    </div>
                }
                <Spinner />
                {(this.props.formMode === FORM_MODE_NEW || this.props.formMode === FORM_MODE_EDIT) && this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"] &&
                    !isViewOnlyOrExternalView() &&
                    <Row className="job-form-btn">
                        <Col md={12}>
                            < button type="button" className="btn btn-primary" onClick={this.saveAndExit}>Save</button>
                            <button type="button" className="btn btn-primary" onClick={this.handleJobJournalBack}>Cancel
                            </button>
                            <Spinner />
                        </Col>
                    </Row>
                }
                {(this.props.formMode === FORM_MODE_VIEW) &&
                    <Row className="job-form-btn">
                        <Col md={12}>
                            <button type="button" className="btn btn-primary" onClick={this.handleJobJournalBack}>Close</button>
                        </Col>
                    </Row>
                }
            </Grid>
        );
    }

    async deleteFile(fileName) {
        let attachmentsList = this.state.attachments.filter(file => {
            return file.fileName != fileName ? file : null
        });
        let { journal, fileList, attachments } = this.state;

        fileList = attachmentsList;
        attachments = attachmentsList;

        this.setState({ fileList, attachments });
    }

    async deleteSelectedFile(fileName, event) {
        event.preventDefault();
        if (this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"]) {
            this.deleteFile(fileName);
        }
    }

    async handleFile(file, event) {
        const fileData = file.fileData;
        let tempArr = this.base64ToArrayBuffer(fileData);
        event.preventDefault();
        this.downloadToClient(fileData, tempArr, file);
    }

    base64ToArrayBuffer(base64) {
        let binaryString = window.atob(base64);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    downloadToClient(fileData, byte, file) {
        let blob = new Blob([byte], { type: "application/octet-stream" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = file.fileName;
        link.click();

    }

    async handleselectedFile(event) {
        this.setState({ filesizeOk: true });
        await this.setState({
            fileList: event.target.files
        })
        let fileCount = this.state.attachments.length + this.state.fileList.length;
        this.setState({ fileCount })
    }

    async saveAndExit() {
        const { fileList, attachments, fileCount } = this.state;
        if (fileList.length > 0) {
            let filesizeOk = true;
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].size > 100e6) {
                    filesizeOk = false;
                }
            }
            this.setState({ filesizeOk });
            if (fileCount < 6) {
                if (filesizeOk === true) {
                    this.handleSaveAndExit();
                } else {
                    this.maxFileSizeError("*You cannot add an attachment with the size of more than 100 MB");
                }
            } else {
                this.maxFileCountError("*You cannot add more than 5 attachments to a single job journal");
            }

        } else {
            this.handleSaveAndExit();
        }

    }

    async handleSaveAndExit() {
        const { fileList, attachments } = this.state;
        const { journal } = this.state;
        const { project, status } = this.props;
        let response = null;
        const projectId = project.id;
        const files = Object.entries(fileList);
        let self = this;
        if (!journal.title) {
            this.handleErrors('Please Enter Title');
            return;
        }
        if (!journal.problem) {
            this.handleErrors('Please Enter Description of Problem');
            return;
        }
        if (!journal.dateDiscovered) {
            this.handleErrors('Please Enter Date Discovered');
            return;
        }
        if (moment(journal.dateResolved).isBefore(moment(journal.dateDiscovered))) {
            this.dateValidationErrorDialog()
            return;
        } else {
            
            if (journal.id) {
                spinnerOn();
                let formData = new FormData();
                formData.append('attachments', new Blob([JSON.stringify(attachments)], {
                    type: "application/json"
                }));

                for (let i = 0; i < files.length; i++) {
                    formData.append('files', files[i][1])
                }

                formData.append('jobjournal', new Blob([JSON.stringify(journal)], {
                    type: "application/json"
                }));
                formData.append('selectedIpsLocations', new Blob([JSON.stringify(this.state.selectedLocationAssets)], {
                    type: "application/json"
                }));
const token = await oktaAuth.getAccessToken();
                await axios({
                    method: 'post',
                    url: `/api/projects/${projectId}/jobjournal/${journal.id}/update`,
                    data: formData,
                    headers: { 
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
                })
                    .then((response) => {
                        self.setState({ filesizeOk: true })
                        spinnerOff();
                    })
                    .catch(function (response) {
                        console.log(response);
                        spinnerOff();
                    })

            } else {
                spinnerOn();
                let formData = new FormData();
                formData.append('jobjournal', new Blob([JSON.stringify(journal)], {
                    type: "application/json"
                }));
                formData.append('selectedIpsLocations', new Blob([JSON.stringify(this.state?.selectedLocationAssets)], {
                    type: "application/json"
                }));

                for (var i = 0; i < files.length; i++) {
                    formData.append('files', files[i][1])
                }
                const token = await oktaAuth.getAccessToken();
                await axios({
                    method: 'post',
                    url: `/api/projects/${projectId}/jobjournal/create`,
                    data: formData,
                     headers: { 
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
                })
                    .then((response) => {
                        self.setState({ filesizeOk: true })
                        spinnerOff();
                    })
                    .catch(function (response) {
                        console.log(response);
                        spinnerOff();
                    })
            }

            if (response && response.errorMessages && response.errorMessages.length > 0) {
                this.handleErrors(response.errorMessages[0]);
            } else {
                this.props.handleRefreshCall();
                this.props.history.push(`/${status}/${project.id}/journal`);
            }
        }
    }

    maxFileSizeError(fileSize) {
        this.setState({ fileSize });
    }

    maxFileCountError(noOfFilesError) {
        this.setState({ noOfFilesError });
    }

    handleErrors(error) {
        this.setState({ error });
        window.scrollTo(0, 0);
    }

    closeErrorBox() {
        const error = null;
        this.setState({ error });
    }

    handleJobJournalBack() {
        this.props.handleRefreshCall();
        this.props.history.push(`/${this.props.status}/${this.props.project.id}/journal`);
    }

    dateValidationErrorDialog() {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className="react-confirm-alert-body" style={{width: 'auto'}}>
                        <h2>Job Journal Verification </h2> <br/>
                        <p> The Date Resolved can not be a date that is BEFORE the Date Discovered. </p> <br/>
                        <div className="center-content">
                            <button
                                className="btn btn-primary start-5"
                                onClick={() => {
                                    this.setState({journal:{...this.state.journal, dateResolved: null}})
                                    onClose();
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                );
            }
        });
    } 

}

 

export default withRouter(NewJobJournal);
